import { useT } from '@/i18n';
import { useEffect, useState } from 'react';

/**
 * Live MM:SS countdown to a manual-transfer (VietQR) payment deadline, ticking
 * every second. Shows "Expired" once the deadline passes - the unpaid-order
 * sweep cancels the order on its next tick. Mirrors the storefront's countdown
 * so the owner sees the same clock the customer does.
 */
export function PaymentCountdown({ expiresAt }: { expiresAt: string }) {
  const t = useT();
  const [remainingMs, setRemainingMs] = useState(() =>
    Math.max(0, new Date(expiresAt).getTime() - Date.now()),
  );
  useEffect(() => {
    const tick = () => setRemainingMs(Math.max(0, new Date(expiresAt).getTime() - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [expiresAt]);

  if (remainingMs <= 0) {
    return (
      <span style={{ color: 'var(--f7-color-red, #ff3b30)', fontWeight: 600 }}>
        {t.orders.expired}
      </span>
    );
  }
  const mins = Math.floor(remainingMs / 60000);
  const secs = Math.floor((remainingMs % 60000) / 1000);
  // Under a minute reads as urgent (red); otherwise plain.
  const urgent = remainingMs < 60_000;
  return (
    <span
      style={{
        fontVariantNumeric: 'tabular-nums',
        fontWeight: 600,
        ...(urgent ? { color: 'var(--f7-color-red, #ff3b30)' } : {}),
      }}
    >
      {mins}:{String(secs).padStart(2, '0')}
    </span>
  );
}
